import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {of} from "rxjs";
import {Divider} from "primeng/divider";
import {StickyFooterComponent} from "../sticky-footer/sticky-footer.component";
import {SubmitButtonComponent} from "../submit-button/submit-button.component";
import {whiteDividerDt} from "../../theme";
import {PaymentService} from "../../services/payment/payment.service";

@Component({
  selector: 'homey-auto-apply-sticky-footer',
  host: {style: 'display: contents'},
  imports: [
    Divider,
    StickyFooterComponent,
    SubmitButtonComponent,
  ],
  templateUrl: './auto-apply-sticky-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoApplyStickyFooterComponent {
  private readonly paymentService = inject(PaymentService);
  readonly aboveTabBar = input(false);

  protected readonly whiteDividerDt = whiteDividerDt;

  protected onAutoApplyClick = () => {
    void this.paymentService.openBenefitsDrawer({disableRouteSync: true});
    return of(undefined);
  };

  protected onSelectApartmentsClick = () => {
    void this.paymentService.openBenefitsDrawer({disableRouteSync: true});
  };
}
